import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";

const { Content, Sider } = Layout;

const graphs = [
  { 
    id: "graph1", 
    title: "Evolución en el tiempo", 
    menuTitle: "Evolución en el tiempo", 
    text: `En total, las niñas y niños han sido víctimas de acoso sexual en mayor medida que de abuso. Sin embargo, ambas formas de violencia han 
          aumentado entre 2017 y 2023, particularmente entre aquellas y aquellos que declaran haber sido víctimas hace más de un año. Actualmente, 
          un 18% de las niñas y niños declaran haber sido víctimas de abuso sexual alguna vez en su vida y un 28% ha sido víctima de acoso.`, 
    link: "https://public.flourish.studio/visualisation/23547228/embed"
  },
  { 
    id: "graph2", 
    title: "Análisis por sexo", 
    menuTitle: "\u2022 Sexo", 
    text: `En ambos tipos de violencia hay brechas de género muy relevantes: las niñas declaran en mayor medida haber sido víctimas de violencia 
          sexual, ya sea abuso o acoso, que los niños. Entre las niñas, la violencia sexual ha tendido aumentar, en ambos tipos, a excepción de 
          la prevalencia del último mes, donde el abuso sexual disminuyó un punto porcentual. Entre los niños, la prevalencia de la violencia 
          sexual se ha mantenido constante.`, 
    link: "https://public.flourish.studio/visualisation/23547369/embed"
  },
  { 
    id: "graph3", 
    title: "Análisis por edad", 
    menuTitle: "\u2022 Edad", 
    text: `Niñas y niños con 15 años o más declaran haber sido víctimas de abuso sexual en el último mes en mayor medida que niñas y niños menores 
          de 15. En el resto de las prevalencias, se replica que niñas y niños más grandes tienden a declarar en mayor medida haber sido víctimas, 
          pero la diferencia es menor. Las niñas y niños más grandes, por lo tanto, tienden a ser víctimas de abuso sexual frecuente en mayor medida.`, 
    link: "https://public.flourish.studio/visualisation/23547943/embed"
  },
  { 
    id: "graph4",
    title: "Análisis por país de nacimiento", 
    menuTitle: "\u2022 País de nacimiento", 
    text: `De acuerdo al país de nacimiento de niñas y niños, se observan algunas diferencias en la proporción que declara ser víctimas de violencia 
          sexual. Respecto al abuso sexual, niñas y niños que nacieron en otros países declaran en mayor medida haber sido víctimas hace más de un 
          año, pero este grupo tuvo una mayor baja en la prevalencia del último mes entre 2017 y 2023. El acoso sexual, por otro lado, es igual de 
          prevalente –o muy parecido– en ambos grupos, pero llama la atención el aumento de niñas y niños nacidos en otros países que declara que 
          fue víctima de acoso hace más de 1 año.`,  
    link: "https://public.flourish.studio/visualisation/23550020/embed"
  },
  { 
    id: "graph5", 
    title: "Análisis por pueblo originario", 
    menuTitle: "\u2022 Pueblo originario", 
    text: `Tanto en 2023 como en 2017, no existen diferencias significativas en la proporción de niñas y niños que han sido víctimas de violencia 
          sexual según si se identifican con algún pueblo originario o no lo hacen.`,  
    link: "https://public.flourish.studio/visualisation/23547568/embed"
  },
  { 
    id: "graph6", 
    title: "Análisis por dependencia administrativa", 
    menuTitle: "\u2022 Dependencia", 
    text: `Se observan diferencias estadísticamente significativas según la dependencia administrativa del establecimiento educacional al que asisten 
          las y los estudiantes. La proporción total –sumando las tres prevalencias– de niñas y niños que reporta abuso sexual en establecimientos 
          particulares pagados se mantiene constante entre 2017 y 2023 (12%). Sin embargo, en ese mismo período, se registra un aumento significativo 
          en los casos reportados por estudiantes de escuelas públicas y particulares subvencionadas.`,  
    link: "https://public.flourish.studio/visualisation/23550186/embed"
  },
  { 
    id: "graph7", 
    title: "Análisis por situación de discapacidad", 
    menuTitle: "\u2022 Discapacidad", 
    text: `Las niñas y niños que se encuentran en situación de discapacidad tienden a ser víctimas de violencia sexual en mayor proporción que 
          aquellas niñas y niños que no. Además, este grupo de niñas y niños presenta un mayor aumento en la proporción que declara violencia sexual, 
          ya sea abuso o acoso sexual, en las tres prevalencias temporales.`,  
    link: "https://public.flourish.studio/visualisation/23550241/embed"
  },
  { 
    id: "graph8", 
    title: "Análisis por macrozona", 
    menuTitle: "\u2022 Macrozona", 
    text: `Hay diferencias por macrozona respecto a la proporción de niñas y niños víctimas de violencia sexual, pero estas son menores. En el tipo 
          de violencia en que hay mayores diferencias es en abuso sexual, particularmente en 2023, donde las niñas y niños que residen en la región 
          metropolitana declaran en mayor medida que han sido víctimas  en su vida.`,  
    link: "https://public.flourish.studio/visualisation/23550900/embed"
  },
  { 
    id: "graph9", 
    title: "Análisis por región", 
    menuTitle: "\u2022 Región", 
    text: `Hay variaciones regionales en la proporción de niñas y niños que declaran haber sido víctimas de violencia sexual, abuso o acoso, sin 
          embargo las diferencias no son tan grandes y no se observan patrones claros. Es importante, de todas maneras, reconocer las diferencias 
          territoriales para intervenir con políticas públicas de forma más eficaz.`,  
    link: "https://public.flourish.studio/visualisation/23550433/embed"
  }
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div>{selectedGraph.text}</div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;

